import * as React from "react";
import * as ReactDOM from "react-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import diyLightTheme = require("diy/material-ui/diyLightTheme");
import Paper from "material-ui/Paper";
import FlatButton from "material-ui/FlatButton";
import $ = require('jquery');

import progressDialogApi = require('diy/progress-dialog/ProgressDialogApi');
import l10n from "diy/util/l10n";

import Dialog from "diy/moments-to-celebrate/components/Dialog";

import websiteData = require("diy/util/websiteData");

let api = require<any>('diy/site-admin/main/api');

export default class ShowroomApplier {

    private selectionContentContainer: HTMLElement;

    destroy() {
        ReactDOM.unmountComponentAtNode(this.selectionContentContainer);
    };

    show(selectionId: string, url: string) {

        this.selectionContentContainer = document.createElement('div');
        this.selectionContentContainer.id = 'addSelectionContent';
        document.body.appendChild(this.selectionContentContainer);

        let styles = this.getStyles();

        const SelectionApplierPlaceholder = () => (
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <Dialog
                    autoDetectWindowHeight={false}
                    width={styles.width}
                    title={l10n('showroomApplier.choice.dialog.title')}
                    titleStyle={styles.title}
                    contentStyle={styles.content}
                    bodyStyle={styles.body}
                    secondaryButtonConfig={{
                        primary: true,
                        label: l10n('cancelLabel'),
                        callback: () => this.hide()
                    }}
                    >
                    <div className="selection-applier-dialog">
                        <FlatButton
                            style={styles.paperButtons}
                            onTouchTap={() => {this.applySelection(false, selectionId, url);}}
                            >
                            <Paper style={styles.paper} zDepth={2}>
                                <img src={this.getSrc('apply-styles.png')} />
                                <p style={styles.paperInnerP}>{l10n('showroomApplier.choice.dialog.keepTheSame')}</p>
                            </Paper>
                        </FlatButton>
                        <FlatButton
                            style={styles.paperButtons}
                            onTouchTap={() => {this.applySelection(true, selectionId, url);}}
                            >
                            <Paper style={styles.paper} zDepth={2}>
                                <img src={this.getSrc('apply-styles-and-content.png')} />
                                <p style={styles.paperInnerP}>{l10n('showroomApplier.choice.dialog.addNewContent')}</p>
                            </Paper>
                        </FlatButton>
                    </div>
                </Dialog>
            </MuiThemeProvider>
        );

        ReactDOM.render(
            <SelectionApplierPlaceholder />,
            this.selectionContentContainer
        );

    };

    hide(): boolean {
        if (this.selectionContentContainer) {
            ReactDOM.unmountComponentAtNode(this.selectionContentContainer);
            this.selectionContentContainer.parentElement.removeChild(this.selectionContentContainer);
            this.selectionContentContainer = null;
        }
        return true;
    };

    private applySelection(withContent: boolean, selectionId: string, url: string) {
        this.hide();
        progressDialogApi.showDialog(
            [],
            {
                image: websiteData.getCdnUrl() + 's/diy/site-admin/showroom/img/loading-bg.jpg',
                imageHeight: 327,
                description: l10n('showroomApplier.applyingInProgress')
            }
        );

        $.post(
            url,
            {
                selectionId: selectionId,
                withContent: withContent ? 1 : 0
            },
            (data) => {
                api.close();
                top.window.location.reload();
            }
        );
    }

    private getSrc(imgName: string) {
        let cdnUrl = websiteData.getCdnUrl();
        return `${cdnUrl}s/diy/site-admin/showroom/img/${imgName}`;
    }

    private getStyles() {
        return {
            width: 472,
            minHeight: 500,
            content: {
                transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
            },
            title: {
                textAlign: "center",
                backgroundColor: "#F3F3F3"
            },
            body: {
                textAlign: "center",
                backgroundColor: "#F3F3F3",
                height: 360
            },
            paperButtons: {
                height: "auto",
                margin: "10px 0px",
                padding: "0 0",
                hoverColor: "white",
                backgroundColor: "transparent",
                display: "flex",
                flexDirection: "column"
            },
            paper: {
                cursor: 'pointer',
                textAlign: "center",
                width: "196px",
                margin: "10px",
                display: 'inline-block'
            },
            paperInnerP: {
                padding: "0px 16px 16px 16px",
                fontSize: "15px",
                lineHeight: "18px",
                color: "#4F565E"
            }
        };
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/showroom/ShowroomApplier.tsx
 **/